import React, { Component } from "react";
import { withRouter } from "../../utils/withRouter";
import Slider from "react-slick";
import {
  getRecipeById,
  addReview,
  getReviews,
  getRelatedRecipes
} from "../../api/api";
import "./RecipeDetails.css";
import ReactGA from "react-ga4";
import { Helmet } from "react-helmet-async";

class RecipeDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      recipe: null,
      checkedIngredients: {},
      loading: true,

      // ⭐ Reviews
      reviews: [],
      user_name: "",
      comment: "",
      rating: 0,
      relatedRecipes: []
    };
  }

  componentDidMount() {
    this.fetchRecipe();
    this.fetchReviews();
    this.fetchRelatedRecipes();

  }


  // ================= FETCH RECIPE =================
  fetchRecipe = async () => {
    const { recipe_id } = this.props.router.params;

    try {
      const res = await getRecipeById(recipe_id);
      const recipe = res.data[0];

      const savedChecks =
        JSON.parse(localStorage.getItem(`recipe_${recipe_id}`)) || {};

      this.setState({
        recipe,
        checkedIngredients: savedChecks,
        loading: false,
      });

      // ✅ ADD THIS BLOCK (TRACK RECIPE VIEW)
      if (recipe) {
        ReactGA.event({
          category: "Recipe",
          action: "View Recipe",
          label: recipe.recipe_title,
          value: recipe.recipe_id
        });
      }

    } catch (err) {
      console.error(err);
    }
  };

  // ================= FETCH REVIEWS =================
  fetchReviews = async () => {
    const { recipe_id } = this.props.router.params;

    try {
      const res = await getReviews(recipe_id);
      this.setState({ reviews: res.data });
    } catch (err) {
      console.error(err);
    }
  };

  // ================= INGREDIENT CHECK =================
  handleCheck = (name) => {
    const { recipe, checkedIngredients } = this.state;

    const updatedChecks = {
      ...checkedIngredients,
      [name]: !checkedIngredients[name],
    };

    this.setState({ checkedIngredients: updatedChecks });

    localStorage.setItem(
      `recipe_${recipe.recipe_id}`,
      JSON.stringify(updatedChecks)
    );
  };

  // ================= COMMENT INPUT =================
  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  // ================= SUBMIT REVIEW =================
  handleReviewSubmit = async (e) => {
    e.preventDefault();

    const { recipe_id } = this.props.router.params;

    const avatars = [
      "chef.jpg",
      "pizza.jpg",
      "burger.jpg",
      "cupcake.jpg",
      "ramen.jpg",
    ];

    const randomAvatar =
      avatars[Math.floor(Math.random() * avatars.length)];

    await addReview({
      recipe_id,
      user_name: this.state.user_name,
      comment: this.state.comment,
      rating: this.state.rating,
      avatar_type: randomAvatar,
    });

    this.setState({
      user_name: "",
      comment: "",
      rating: 0,
    });

    this.fetchReviews();
  };
  // ================= FETCH RELATED RECIPES =================
  fetchRelatedRecipes = async () => {
    const { recipe_id } = this.props.router.params;

    try {
      const res = await getRelatedRecipes(recipe_id);

      this.setState({
        relatedRecipes: res.data
      });

    } catch (err) {
      console.error(err);
    }
  };
  render() {
    const sliderSettings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      responsive: [
        {
          breakpoint: 992,
          settings: { slidesToShow: 2 }
        },
        {
          breakpoint: 576,
          settings: { slidesToShow: 1 }
        }
      ]
    };

    const {
      recipe,
      checkedIngredients,
      loading,
      reviews,
      rating,
    } = this.state;

    if (loading) return null;
    if (!recipe) return <p className="text-center">No recipe found</p>;

    const ingredients =
      typeof recipe.ingredients === "string"
        ? JSON.parse(recipe.ingredients)
        : recipe.ingredients;

    const cookingSteps = recipe.cooking_process
      ?.split(".")
      .filter((step) => step.trim() !== "");

    const tips = recipe.tips_facts
      ?.split(".")
      .filter((tip) => tip.trim() !== "");

    const averageRating =
      reviews.length > 0
        ? reviews.reduce((acc, cur) => acc + cur.rating, 0) /
        reviews.length
        : 0;
    const pageTitle = `${recipe.recipe_title} | Flavours Nest`;

    const pageDescription =
      recipe.recipe_description?.substring(0, 150) ||
      "Delicious recipe with step-by-step instructions.";

    const currentUrl = window.location.href;

    const ingredientsList = ingredients?.map(i => i.ingredient_name);

    const recipeSchema = {
      "@context": "https://schema.org",
      "@type": "Recipe",
      name: recipe.recipe_title,
      image: recipe.recipe_image,
      description: recipe.recipe_description,
      recipeIngredient: ingredientsList,
      recipeInstructions: cookingSteps?.map((step, index) => ({
        "@type": "HowToStep",
        text: step.trim()
      })),
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: averageRating.toFixed(1),
        reviewCount: reviews.length
      }
    };
    const checkedCount =
      Object.values(checkedIngredients).filter(Boolean).length;
    return (

      <section className="recipe-details">
        <Helmet>
          <title>{pageTitle}</title>

          <meta name="description" content={pageDescription} />

          <link rel="canonical" href={currentUrl} />

          {/* Open Graph */}
          <meta property="og:title" content={pageTitle} />
          <meta property="og:description" content={pageDescription} />
          <meta property="og:image" content={recipe.recipe_image} />
          <meta property="og:url" content={currentUrl} />
          <meta property="og:type" content="article" />

          {/* Twitter */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={pageTitle} />
          <meta name="twitter:description" content={pageDescription} />
          <meta name="twitter:image" content={recipe.recipe_image} />

          {/* 🔥 Recipe Schema */}
          <script type="application/ld+json">
            {JSON.stringify(recipeSchema)}
          </script>
        </Helmet>
        {/* HERO */}
        <div className="recipe-hero text-light">
          <h1 className="recipe-header">{recipe.recipe_title}</h1>
          <p>{recipe.recipe_description}</p>
          <span className="avg-stars">
            {"★".repeat(Math.round(averageRating))}
            {"☆".repeat(5 - Math.round(averageRating))}
          </span>
          <span className="review-count">
            ({reviews.length} {reviews.length === 1 ? "Review" : "Reviews"})
            
          </span>
        </div>

        <div className="container py-5">
          <div className="row">

            {/* LEFT COLUMN */}
            <div className="col-lg-4 col-md-12">

              <div className="recipe-image-box">
                {console.log(recipe.recipe_image)}
                <img
                  src={recipe.recipe_image}
                  alt={recipe.recipe_title}
                  className="img-fluid"
                />
              </div>

              <div className="ingredients-card mt-4">

                <div className="ingredient-header">
                  <h3>🛒 Ingredients</h3>

                  <div className="ingredient-progress">
                    {checkedCount} / {ingredients.length} Checked ✓
                  </div>
                </div>

                {ingredients?.map((item, index) => {
                  const isChecked =
                    checkedIngredients[item.ingredient_name] || false;

                  return (
                    <div
                      key={index}
                      className={`ingredient-item ${isChecked ? "checked" : ""
                        }`}
                    >
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={() =>
                          this.handleCheck(item.ingredient_name)
                        }
                      />

                      <div className="ingredient-content">
                        <div className="ingredient-name">
                          {item.ingredient_name}
                        </div>

                        <div className="ingredient-qty">
                          {item.quantity} {item.unit}
                        </div>

                        {item.preparation && (
                          <div className="ingredient-prep">
                            {item.preparation}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* RIGHT COLUMN */}
            <div className="col-lg-8 col-md-12">

              <div className="details-section">
                <h3>👨‍🍳 Cooking Process</h3>
                {cookingSteps?.map((step, index) => (
                  <p key={index} className="process-line">
                    {index + 1}.{step.trim()}.
                  </p>
                ))}
              </div>

              <div className="details-section mt-4">
                <h3>✨ Tips & Facts</h3>
                <ul>
                  {tips?.map((tip, index) => (
                    <li key={index}>{tip.trim()}.</li>
                  ))}
                </ul>
              </div>
              {/* ================= RELATED RECIPES ================= */}

              {this.state.relatedRecipes.length > 0 && (
                <div className="related-recipes mt-5">

                  <h3 className="mb-4">🍴 You may also like</h3>

                  <Slider {...sliderSettings}>

                    {this.state.relatedRecipes.map((item) => (

                      <div
                        key={item.recipe_id}
                        className="related-recipe-card"
                        onClick={() =>
                          this.props.router.navigate(`/recipe/${item.recipe_id}`)
                        }
                      >

                        <img
                          src={item.recipe_image}
                          alt={item.recipe_title}
                          className="related-recipe-image"
                        />

                        <div className="related-recipe-content">

                          <h6>{item.recipe_title}</h6>

                          <p>
                            {item.recipe_description?.substring(0, 60)}...
                          </p>

                        </div>

                      </div>

                    ))}

                  </Slider>

                </div>
              )}

              {/* ================= COMMENT FORM ================= */}
              <div className="review-form mt-5">
                <h3>💬 Leave a Review</h3>

                <form onSubmit={this.handleReviewSubmit}>

                  <input
                    type="text"
                    name="user_name"
                    placeholder="Your Name"
                    className="form-control mb-3"
                    value={this.state.user_name}
                    onChange={this.handleInputChange}
                    required
                  />

                  {/* ⭐ Rating */}
                  <div className="rating-stars mb-3">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <span
                        key={star}
                        onClick={() => this.setState({ rating: star })}
                        style={{
                          cursor: "pointer",
                          fontSize: "24px",
                          color:
                            rating >= star ? "#ff7a00" : "#ccc",
                        }}
                      >
                        ★
                      </span>
                    ))}
                  </div>

                  <textarea
                    name="comment"
                    rows="4"
                    className="form-control mb-3"
                    placeholder="Write your thoughts..."
                    value={this.state.comment}
                    onChange={this.handleInputChange}
                    required
                  />

                  <button className="btn btn-warning">
                    Post Review 🍲
                  </button>
                </form>
              </div>

              {/* ================= REVIEWS LIST ================= */}
              <div className="reviews-section mt-5">
                <h3 className="mb-4">🍴 Foodie Reviews</h3>

                {reviews.map((review) => (
                  <div
                    key={review.review_id}
                    className="review-card p-4 mb-4"
                  >
                    <div className="review-layout">

                      {/* LEFT SIDE */}
                      <div className="review-left text-center">
                        <img
                          src={`/avatars/${review.avatar_type}`}
                          alt="avatar"
                          className="review-avatar"
                        />

                        <div className="review-rating mt-2">
                          {"★".repeat(review.rating)}
                        </div>
                      </div>

                      {/* RIGHT SIDE */}
                      <div className="review-right">
                        <h6 className="review-name">
                          {review.user_name}
                        </h6>

                        <p className="review-comment">
                          {review.comment}
                        </p>
                      </div>

                    </div>
                  </div>
                ))}
              </div>

            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default withRouter(RecipeDetails);